<template>
    <div>
        <el-dialog :title="selectDetail.title" :visible.sync="showDialog" :modal-append-to-body=false
            :width="selectDetail.width" v-dialog-drag :destroy-on-close="true" :modal=false :before-close="cancel">
            <div ref="flowchart" id="flowchart" :style="{ width: '100%', height: selectDetail.height }"></div>
            <span v-if="selectDetail.remark"><i class="el-icon-warning-outline"></i>{{ selectDetail.remark }}</span>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" class="title" @click="cancel">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import { Graph } from '@antv/g6';

export default {
    name: "FlowChart",
    props: {
        showDialog: {
            default: false
        },
        selectDetail: {
            default: () => ({})
        }
    },
    data() {
        return {
            graph:'',
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.initFlowchart();
        })
    },
    methods: {
        cancel() {
            this.$emit('submit', 'cancel')
        },
        initFlowchart() {
            if (this.graph){
                this.graph.clear()
            }
            const container = this.$refs.flowchart;
            const width = container.scrollWidth;
            const height = container.scrollHeight || 500;
            this. graph = new Graph({
                autoFit:'view',
                container: 'flowchart',
                width,
                height,
                data: {
                    nodes: this.selectDetail.nodes,
                    edges: this.selectDetail.edges
                },
                layout: {
                    type: 'antv-dagre',
                    rankdir: 'LR', // 从左到右布局
                    ranker:'network-simplex',
                    nodesep: this.selectDetail.nodesep,   // 节点之间的间距
                    ranksepFunc: (d) => d.data.number ? d.data.number: this.selectDetail.ranksep,  // 层级之间的间距
                    controlPoints: false, // 启用控制点
                },
                node: {
                    style: {
                        ports: [
                            { key: 'top', placement: 'top',  },
                            { key: 'right', placement: 'right', },
                            { key: 'bottom', placement: 'bottom',  },
                            { key: 'left', placement: 'left',  },
                        ],
                        labelText: (d) => d.data.label,
                        labelFontSize: 11,
                        labelMaxLines:5,
                        labelWordWrap:true,
                        labelFill:'#ffffff',
                        labelPlacement:'center'
                    },
                },
                edge: {
            
                    style: {
                        router: { type: 'orth'},
                        labelText: (d) => d.data.label,
                        labelPlacement: 0.4,
                        labelAutoRotate:false,
                        labelBackground:true,
                        labelBackgroundFill:'#ffffff',
                        labelFill:'black',
                        labelWordWrap:true,
                        labelFontSize:11,
                        labelMaxWidth:'70%',
                        labelMaxLines:2,
                        endArrow:true,
                        endArrowFill: 'black', // 边终点箭头填充颜色
                    },
                },
            });
            this.graph.render();
            // 居中显示图
            this.graph.fitView();
        }
    }
};
</script>

<style scoped>
/* 添加样式以控制容器布局 */

</style>
